"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The EdelmetallKondition model module.
 * @module model/EdelmetallKondition
 * @version 1.0.44
 */
var EdelmetallKondition = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>EdelmetallKondition</code>.
   * 
   * @alias module:model/EdelmetallKondition
   * @param kennziffer {String} 
   * @param bezeichnung {String} 
   * @param emBpBuyPreis {Number} Preis im Edelmetall Verkauf Shop
   * @param emBpSellPreis {Number} Preis im Edelmetall Ankauf Shop
   * @param emWlBuyPreis {Number} Preis im Edelmetall Kunden Shop
   * @param emBpBuyKondition {Number} Kondition im Edelmetall Verkauf Shop
   * @param emBpSellKondition {Number} Kondition für Edelmetall Ankauf Shop
   * @param emWlBuyKondition {Number} Kondition im Edelmetall Kunden Shop
   */
  function EdelmetallKondition(kennziffer, bezeichnung, emBpBuyPreis, emBpSellPreis, emWlBuyPreis, emBpBuyKondition, emBpSellKondition, emWlBuyKondition) {
    _classCallCheck(this, EdelmetallKondition);
    EdelmetallKondition.initialize(this, kennziffer, bezeichnung, emBpBuyPreis, emBpSellPreis, emWlBuyPreis, emBpBuyKondition, emBpSellKondition, emWlBuyKondition);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(EdelmetallKondition, null, [{
    key: "initialize",
    value: function initialize(obj, kennziffer, bezeichnung, emBpBuyPreis, emBpSellPreis, emWlBuyPreis, emBpBuyKondition, emBpSellKondition, emWlBuyKondition) {
      obj['kennziffer'] = kennziffer;
      obj['bezeichnung'] = bezeichnung;
      obj['emBpBuyPreis'] = emBpBuyPreis;
      obj['emBpSellPreis'] = emBpSellPreis;
      obj['emWlBuyPreis'] = emWlBuyPreis;
      obj['emBpBuyKondition'] = emBpBuyKondition;
      obj['emBpSellKondition'] = emBpSellKondition;
      obj['emWlBuyKondition'] = emWlBuyKondition;
    }

    /**
     * Constructs a <code>EdelmetallKondition</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EdelmetallKondition} obj Optional instance to populate.
     * @return {module:model/EdelmetallKondition} The populated <code>EdelmetallKondition</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new EdelmetallKondition();
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'String');
        }
        if (data.hasOwnProperty('bezeichnung')) {
          obj['bezeichnung'] = _ApiClient.default.convertToType(data['bezeichnung'], 'String');
        }
        if (data.hasOwnProperty('emBpBuyPreis')) {
          obj['emBpBuyPreis'] = _ApiClient.default.convertToType(data['emBpBuyPreis'], 'Number');
        }
        if (data.hasOwnProperty('emBpSellPreis')) {
          obj['emBpSellPreis'] = _ApiClient.default.convertToType(data['emBpSellPreis'], 'Number');
        }
        if (data.hasOwnProperty('emWlBuyPreis')) {
          obj['emWlBuyPreis'] = _ApiClient.default.convertToType(data['emWlBuyPreis'], 'Number');
        }
        if (data.hasOwnProperty('emBpBuyKondition')) {
          obj['emBpBuyKondition'] = _ApiClient.default.convertToType(data['emBpBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('emBpSellKondition')) {
          obj['emBpSellKondition'] = _ApiClient.default.convertToType(data['emBpSellKondition'], 'Number');
        }
        if (data.hasOwnProperty('emWlBuyKondition')) {
          obj['emWlBuyKondition'] = _ApiClient.default.convertToType(data['emWlBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('changed')) {
          obj['changed'] = _ApiClient.default.convertToType(data['changed'], 'Boolean');
        }
        if (data.hasOwnProperty('additionalProperties')) {
          obj['additionalProperties'] = _ApiClient.default.convertToType(data['additionalProperties'], Object);
        }
        if (data.hasOwnProperty('emBpBuyChanged')) {
          obj['emBpBuyChanged'] = _ApiClient.default.convertToType(data['emBpBuyChanged'], 'Boolean');
        }
        if (data.hasOwnProperty('emWlBuyChanged')) {
          obj['emWlBuyChanged'] = _ApiClient.default.convertToType(data['emWlBuyChanged'], 'Boolean');
        }
        if (data.hasOwnProperty('emMaBuyChanged')) {
          obj['emMaBuyChanged'] = _ApiClient.default.convertToType(data['emMaBuyChanged'], 'Boolean');
        }
        if (data.hasOwnProperty('emMaBuyKondition')) {
          obj['emMaBuyKondition'] = _ApiClient.default.convertToType(data['emMaBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('emMaBuyPreis')) {
          obj['emMaBuyPreis'] = _ApiClient.default.convertToType(data['emMaBuyPreis'], 'Number');
        }
        if (data.hasOwnProperty('escapedHeader')) {
          obj['escapedHeader'] = _ApiClient.default.convertToType(data['escapedHeader'], Object);
        }
        if (data.hasOwnProperty('header')) {
          obj['header'] = _ApiClient.default.convertToType(data['header'], Object);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EdelmetallKondition</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EdelmetallKondition</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(EdelmetallKondition.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['kennziffer'] && !(typeof data['kennziffer'] === 'string' || data['kennziffer'] instanceof String)) {
        throw new Error("Expected the field `kennziffer` to be a primitive type in the JSON string but got " + data['kennziffer']);
      }
      // ensure the json data is a string
      if (data['bezeichnung'] && !(typeof data['bezeichnung'] === 'string' || data['bezeichnung'] instanceof String)) {
        throw new Error("Expected the field `bezeichnung` to be a primitive type in the JSON string but got " + data['bezeichnung']);
      }
      return true;
    }
  }]);
}();
EdelmetallKondition.RequiredProperties = ["kennziffer", "bezeichnung", "emBpBuyPreis", "emBpSellPreis", "emWlBuyPreis", "emBpBuyKondition", "emBpSellKondition", "emWlBuyKondition"];

/**
 * @member {String} kennziffer
 */
EdelmetallKondition.prototype['kennziffer'] = undefined;

/**
 * @member {String} bezeichnung
 */
EdelmetallKondition.prototype['bezeichnung'] = undefined;

/**
 * Preis im Edelmetall Verkauf Shop
 * @member {Number} emBpBuyPreis
 */
EdelmetallKondition.prototype['emBpBuyPreis'] = undefined;

/**
 * Preis im Edelmetall Ankauf Shop
 * @member {Number} emBpSellPreis
 */
EdelmetallKondition.prototype['emBpSellPreis'] = undefined;

/**
 * Preis im Edelmetall Kunden Shop
 * @member {Number} emWlBuyPreis
 */
EdelmetallKondition.prototype['emWlBuyPreis'] = undefined;

/**
 * Kondition im Edelmetall Verkauf Shop
 * @member {Number} emBpBuyKondition
 */
EdelmetallKondition.prototype['emBpBuyKondition'] = undefined;

/**
 * Kondition für Edelmetall Ankauf Shop
 * @member {Number} emBpSellKondition
 */
EdelmetallKondition.prototype['emBpSellKondition'] = undefined;

/**
 * Kondition im Edelmetall Kunden Shop
 * @member {Number} emWlBuyKondition
 */
EdelmetallKondition.prototype['emWlBuyKondition'] = undefined;

/**
 * Wurde der Datensatz geändert
 * @member {Boolean} changed
 */
EdelmetallKondition.prototype['changed'] = undefined;

/**
 * @member {Object} additionalProperties
 */
EdelmetallKondition.prototype['additionalProperties'] = undefined;

/**
 * Wurde emBpBuyKondition geändert
 * @member {Boolean} emBpBuyChanged
 */
EdelmetallKondition.prototype['emBpBuyChanged'] = undefined;

/**
 * Wurde emWlBuyKondition geändert
 * @member {Boolean} emWlBuyChanged
 */
EdelmetallKondition.prototype['emWlBuyChanged'] = undefined;

/**
 * 
 * @member {Boolean} emMaBuyChanged
 */
EdelmetallKondition.prototype['emMaBuyChanged'] = undefined;

/**
 * 
 * @member {Number} emMaBuyKondition
 */
EdelmetallKondition.prototype['emMaBuyKondition'] = undefined;

/**
 * 
 * @member {Number} emMaBuyPreis
 */
EdelmetallKondition.prototype['emMaBuyPreis'] = undefined;

/**
 * @member {Object} escapedHeader
 */
EdelmetallKondition.prototype['escapedHeader'] = undefined;

/**
 * @member {Object} header
 */
EdelmetallKondition.prototype['header'] = undefined;
var _default = exports.default = EdelmetallKondition;